import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { IIncomingRoom } from "../../../app/chatAgent/types";
import Chat from "./Chat";
import { useLocation } from "react-router-dom";

interface IProps {
    items: Array<IIncomingRoom>;
}

const ChatList: FC<IProps> = ({ items }) => {
    const location = useLocation()
    const { pathname } = location
    const { activeRoom } = useSelector((state: RootState) => state.chatagent);
    useEffect(() => {
    }, [items]);
    return (
        <div className="user-list border-none rounded-lg">
            {items.map((user) => {
                let isSelected = false;
                if (activeRoom.roomId == user.roomId && pathname==`/chat/${activeRoom.roomId}`) isSelected  = true;
                return <Chat path={`/chat/${user.roomId}`} key={user.roomId} user={user} isSelected={isSelected} />
            })
            }
        </div>
    );
};

export default ChatList;
